import { Button } from '@/components/ui/button';
import * as Card from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import dayjs from 'dayjs';
import { For } from 'solid-js';
import { useService } from 'solid-services';
import { css } from 'styled-system/css';
import { Flex, Grid } from 'styled-system/jsx';
import { useCalendarState } from '../../../state/events/calendar-state';

export default function Month() {
  const { viewDate, days, setActiveEvent } = useService(useCalendarState)();
  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <Grid gridTemplateRows='auto 1fr' height='100%'>
      <Grid columns={7}>
        <For each={weekDays}>
          {(day) => (
            <Text fontSize='xs' color='fg.subtle' textAlign="left" pl='3'>
              {day}
            </Text>
          )}
        </For>
      </Grid>

      <Grid columns={7}>
        <For each={days()}>
          {(day) => {
            const isToday = day.date.isSame(dayjs(), 'day');
            const isCurrentMonth = day.date.isSame(viewDate(), 'month');

            return (
              <Card.Root
                class={css({
                  p: 3,
                  border: isToday ? '2px solid' : 'none',
                  borderColor: isToday ? 'jade.10' : '',
                  borderRadius: 'none',
                  display: 'grid',
                  gap: 3,
                  gridTemplateColumns: 'auto 1fr',
                })}
                style={{ opacity: isCurrentMonth ? 1 : 0.6 }}
              >
                <Text
                  fontWeight={isToday ? 'bold' : 'normal'}
                  textAlign="center"
                  color='fg.muted'
                >
                  {day.date.format('D')}
                </Text>

                <Grid gap={2} alignContent='start'>
                  <For each={day.events}>
                    {(event) => (
                      <Button
                        colorPalette='jade'
                        variant="outline"
                        size="sm"
                        p={2}
                        h='auto'
                        onClick={() => setActiveEvent(event)}
                        class={css({ justifyContent: 'flex-start', whiteSpace: 'normal' })}
                      >
                        <Grid w='100%' gap={0}>
                          <Text truncate fontSize='sm' fontWeight='bold' textAlign='left'>
                            {event.group}
                          </Text>
                          <Flex justifyContent='space-between' alignItems='center'>
                            <Text fontSize='xs' color='fg.muted'>{event.duration_mins}m</Text>
                            <Text fontSize='xs' color='fg.muted'>{event.localTime.format('HH:mm')}</Text>
                          </Flex>
                        </Grid>
                      </Button>
                    )}
                  </For>
                </Grid>
              </Card.Root>
            );
          }}
        </For>
      </Grid>
    </Grid>
  );
}
